/*  ==========================================================================
    IMPRESSIONS V4

    INFO:
    - needs "object-fit-images" (https://github.com/bfred-it/object-fit-images)
      to make object fit possible for images in older browsers (especially ie11)
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import objectFitImages from 'object-fit-images';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initImpressionsV4($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // object fit fix for older browsers (especially ie11)
    let images = $element.find('img');
    objectFitImages(images, {
        watchMQ: true
    });

    // initialize slider
    let $sliderContainer = $element.find('.bn-impressions-v4__slider'),
        sliderOverrides = {
            fade: false,
            nextArrow: vars.slick_nextArrowV2,
            pauseOnHover: true,
            prevArrow: vars.slick_prevArrowV2
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    $('.bn-impressions-v4__head').each(function () {
        if($(this).find('.bn-impressions-v4__title').length){
            $(this).addClass('bn-titleset');
        }
    });
}


// WEBPACK FOOTER //
// ./source/js/modules/lib/impressions-v4.js